import { render, staticRenderFns } from "./BasicEraInfo.vue?vue&type=template&id=2677545c&scoped=true&"
import script from "./BasicEraInfo.vue?vue&type=script&lang=js&"
export * from "./BasicEraInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicEraInfo.vue?vue&type=style&index=0&id=2677545c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2677545c",
  null
  
)

export default component.exports